export default __webpack_public_path__ + "static/media/tooltip-add.cae96536.svg";